import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { RepTop30Item } from "@api/repTop30";

export type RepTop30State = {
  data: RepTop30Item[];
  selectedRep: { id: string; name: string } | null;
  isLoading: boolean;
  error: string;
};

const initialState: RepTop30State = {
  data: [],
  selectedRep: null,
  isLoading: false,
  error: "",
};

export const repTop30Slice = createSlice({
  name: "repTop30",
  initialState,
  reducers: {
    setRepTop30Data: (
      state,
      { payload }: PayloadAction<RepTop30Item[]>
    ) => {
      state.data = payload;
      state.isLoading = false;
    },
    setSelectedRep: (state, { payload }: PayloadAction<{ id: string; name: string } | null>) => {
      state.selectedRep = payload;
    },
    setRepTop30Loading: (state) => {
      state.isLoading = true;
      state.error = "";
    },
    setRepTop30Error: (state, { payload }: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = payload;
    },
    updateRepTop30RelationshipLevel: (
      state,
      { payload }: PayloadAction<{ id: string; level: number | null }>
    ) => {
      const index = state.data.findIndex((item) => item.id === payload.id);
      if (index !== -1) {
        state.data[index] = {
          ...state.data[index],
          relationship_level: payload.level,
        };
      }
    },
    resetRepTop30: (state) => {
      state.data = initialState.data;
      state.selectedRep = initialState.selectedRep;
      state.isLoading = initialState.isLoading;
      state.error = initialState.error;
    },
  },
});

export const {
  setRepTop30Data,
  setSelectedRep,
  setRepTop30Loading,
  setRepTop30Error,
  updateRepTop30RelationshipLevel,
  resetRepTop30,
} = repTop30Slice.actions;

export default repTop30Slice.reducer;
